module.exports = __webpack_public_path__ + "static/media/sd-card.877ac1d8.svg";